import { Message, Form } from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';

const FormError = ({ error }) =>
  error ? (
    <Form.Field>
      <Message error={!!error} content={error} icon="exclamation circle" />
    </Form.Field>
  ) : null;

FormError.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.node
  ])
};

export default FormError;
